import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/base/Breadcrumb';
import ComicCard from '@/components/base/ComicCard';
import { categories } from '@/mocks/categories';
import { comics } from '@/mocks/comics';
import { type FC } from 'react';

const categoryMetaMap: Record<string, { title: string; description: string; keywords: string; heroImage: string }> = {
  action: {
    title: '热血漫画 - 韩国热血漫画免费在线阅读 - 韩漫画网',
    description: '韩漫画网热血漫画专区，提供最新最全的韩国热血漫画免费在线阅读。激燃战斗、热血沸腾，每日更新，高清画质。',
    keywords: '热血漫画,韩国热血漫画,免费热血漫画,热血韩漫,热血漫画在线阅读',
    heroImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20background%2C%20epic%20battle%20scene%20with%20warriors%20and%20energy%20effects%2C%20dramatic%20warm%20orange%20red%20lighting%2C%20dynamic%20composition%2C%20clean%20areas%20for%20text%20overlay%2C%20anime%20manhwa%20art%20style&width=1920&height=600&seq=cat-hero-action&orientation=landscape',
  },
  romance: {
    title: '恋爱漫画 - 韩国恋爱漫画免费在线阅读 - 韩漫画网',
    description: '韩漫画网恋爱漫画专区，提供最全的韩国恋爱漫画免费在线阅读。甜蜜浪漫、心动故事，每日更新，高清画质。',
    keywords: '恋爱漫画,韩国恋爱漫画,免费恋爱漫画,恋爱韩漫,恋爱漫画在线阅读',
    heroImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20background%2C%20beautiful%20couple%20under%20blooming%20cherry%20blossoms%2C%20soft%20pink%20warm%20lighting%2C%20romantic%20atmosphere%2C%20clean%20composition%20with%20space%20for%20text%2C%20anime%20manhwa%20art%20style&width=1920&height=600&seq=cat-hero-romance&orientation=landscape',
  },
  fantasy: {
    title: '奇幻漫画 - 韩国奇幻漫画免费在线阅读 - 韩漫画网',
    description: '韩漫画网奇幻漫画专区，提供最丰富的韩国奇幻漫画免费在线阅读。异世界冒险、魔法与龙，每日更新，高清画质。',
    keywords: '奇幻漫画,韩国奇幻漫画,免费奇幻漫画,奇幻韩漫,奇幻漫画在线阅读',
    heroImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20background%2C%20magical%20world%20with%20floating%20castles%20and%20dragons%2C%20mystical%20purple%20and%20teal%20lighting%2C%20fantastical%20atmosphere%2C%20clean%20composition%20with%20text%20space%2C%20anime%20manhwa%20art%20style&width=1920&height=600&seq=cat-hero-fantasy&orientation=landscape',
  },
  mystery: {
    title: '悬疑漫画 - 韩国悬疑漫画免费在线阅读 - 韩漫画网',
    description: '韩漫画网悬疑漫画专区，提供最精彩的韩国悬疑漫画免费在线阅读。烧脑推理、惊险刺激，每日更新，高清画质。',
    keywords: '悬疑漫画,韩国悬疑漫画,免费悬疑漫画,悬疑韩漫,悬疑漫画在线阅读',
    heroImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20background%2C%20dark%20detective%20office%20with%20clues%20and%20evidence%20on%20desk%2C%20moody%20film%20noir%20lighting%2C%20sepia%20brown%20atmosphere%2C%20clean%20composition%20for%20text%2C%20anime%20manhwa%20art%20style&width=1920&height=600&seq=cat-hero-mystery&orientation=landscape',
  },
  comedy: {
    title: '搞笑漫画 - 韩国搞笑漫画免费在线阅读 - 韩漫画网',
    description: '韩漫画网搞笑漫画专区，提供最好笑的韩国搞笑漫画免费在线阅读。轻松幽默、爆笑不断，每日更新，高清画质。',
    keywords: '搞笑漫画,韩国搞笑漫画,免费搞笑漫画,搞笑韩漫,搞笑漫画在线阅读',
    heroImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20background%2C%20colorful%20funny%20characters%20with%20exaggerated%20expressions%2C%20bright%20playful%20lighting%2C%20lighthearted%20atmosphere%2C%20clean%20composition%20for%20text%2C%20anime%20manhwa%20art%20style&width=1920&height=600&seq=cat-hero-comedy&orientation=landscape',
  },
  'slice-of-life': {
    title: '日常漫画 - 韩国日常漫画免费在线阅读 - 韩漫画网',
    description: '韩漫画网日常漫画专区，提供最温馨的韩国日常漫画免费在线阅读。治愈暖心、真实感人，每日更新，高清画质。',
    keywords: '日常漫画,韩国日常漫画,免费日常漫画,日常韩漫,日常漫画在线阅读',
    heroImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20background%2C%20cozy%20room%20with%20warm%20sunlight%20through%20window%2C%20peaceful%20and%20serene%20atmosphere%2C%20soft%20warm%20cream%20lighting%2C%20clean%20composition%20for%20text%2C%20anime%20manhwa%20art%20style&width=1920&height=600&seq=cat-hero-slice&orientation=landscape',
  },
};

const CategoryPage: FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const meta = categoryMetaMap[slug || ''] || categoryMetaMap.action;
  const relatedComics = comics.filter(
    (c) => category && c.category === category.name
  );

  if (!category) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <p className="text-foreground-500">分类未找到</p>
      </div>
    );
  }

  const categorySchema = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: 'http://chinahangnuo.com/' },
          { '@type': 'ListItem', position: 2, name: `${category.name}漫画`, item: `http://chinahangnuo.com/category/${slug}` },
        ],
      },
      {
        '@type': 'CollectionPage',
        name: `${category.name}漫画 - 韩漫画网`,
        url: `http://chinahangnuo.com/category/${slug}`,
        description: meta.description,
        isPartOf: { '@type': 'WebSite', name: '韩漫画网', url: 'http://chinahangnuo.com/' },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title={meta.title}
        description={meta.description}
        keywords={meta.keywords}
        canonicalUrl={`http://chinahangnuo.com/category/${slug}`}
        schema={categorySchema}
      />

      <Breadcrumb items={[{ name: '首页', path: '/' }, { name: `${category.name}漫画` }]} />

      <section className="relative w-full h-[280px] md:h-[340px] overflow-hidden">
        <img
          src={meta.heroImage}
          alt={`${category.name}漫画`}
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center px-4">
            <p className="text-accent-400 text-sm font-medium mb-2 tracking-wider">
              韩国漫画 · 免费阅读
            </p>
            <h1 className="text-2xl md:text-4xl font-bold font-heading text-background-50">
              {category.name}漫画
            </h1>
            <p className="text-background-50/70 text-sm mt-3 max-w-md mx-auto leading-relaxed">
              {category.description}
            </p>
          </div>
        </div>
      </section>

      <section className="px-4 md:px-6 py-10 md:py-14 bg-background-50">
        <div className="max-w-[1200px] mx-auto">
          <div className="flex items-center justify-between mb-8">
            <div>
              <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-900">
                全部{category.name}漫画
              </h2>
              <p className="text-sm text-foreground-500 mt-1">共 {relatedComics.length} 部作品</p>
            </div>
            <div className="flex items-center gap-3">
              <button className="text-xs px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 font-medium whitespace-nowrap">
                默认排序
              </button>
              <button className="text-xs px-3 py-1.5 rounded-full bg-background-200 text-foreground-600 font-medium whitespace-nowrap">
                热度最高
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
            {relatedComics.map((comic) => (
              <ComicCard key={comic.id} comic={comic} />
            ))}
          </div>
        </div>
      </section>

      <section className="flex flex-col lg:flex-row">
        <div className="relative lg:w-1/2 h-[260px] md:h-[360px] overflow-hidden">
          <img
            src={category.image}
            alt={`${category.name}漫画推荐`}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
          <div className="absolute bottom-5 left-5 md:bottom-8 md:left-8">
            <p className="text-xs text-background-50/70 mb-1 tracking-wider">热门推荐</p>
            <h3 className="text-lg md:text-2xl font-bold font-heading text-background-50 leading-tight">
              更多{category.name}
              <br />
              精彩漫画
            </h3>
          </div>
        </div>
        <div className="lg:w-1/2 bg-background-100 flex items-center justify-center px-6 md:px-12 py-10 md:py-14">
          <div className="max-w-md text-center">
            <h3 className="text-xl md:text-2xl font-bold font-heading text-foreground-900">
              还没找到喜欢的？
            </h3>
            <p className="text-sm text-foreground-600 mt-3 leading-relaxed">
              韩漫画网拥有超过<strong>12,000部</strong>韩国漫画资源，每日持续更新。按分类浏览，总能找到你喜欢的作品。
            </p>
            <div className="flex flex-wrap items-center justify-center gap-2 mt-5">
              {categories.map((c) => (
                <Link
                  key={c.id}
                  to={`/category/${c.slug}`}
                  className={`text-xs px-3 py-1.5 rounded-full font-medium whitespace-nowrap transition-colors duration-200 ${
                    c.slug === slug
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-background-200 text-foreground-600 hover:bg-accent-100 hover:text-accent-700'
                  }`}
                >
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CategoryPage;